module.exports = __webpack_public_path__ + "media/assets/img/pages/forgot-password-63f5a96a010605a3708c757d6c28f26f.png";